export default {
  dashboard: {
    breadcrumb: {
      home: 'Home',
      dashboardPage: 'Dashboard',
      workSpace: 'Work Space',
    },
    analysis: {
      visitingData: 'Data Flow In A Week',
      serviceWaterLine: 'Service Level Variation',
      userVisiting: 'User Visiting',
      requirementType: 'Requirement Type Tendency',
      taskComplete: 'Task Completed Situation',
    },
    monitor: {
      taskComplete: 'Task Completion Monitor',
      occupancy: 'Occupancy Rate',
      userDistribute: 'User Distribution',
      tendency: 'Tendency',
      taskExec: 'Task Execution',
    },
    workSpace: {
      name: 'Work Space',
      descriptionPrefix: 'Hello',
      descriptionSuffix: 'welcome to your work space',
      title: 'Front-End Expert',
      role: 'DevUI-Committer',
    },
  },
};
